











































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";

import { mdiTwitter, mdiFacebook } from "@mdi/js";
import { DistroDataSet } from "./classes/DistroDataSet";
import { License } from "./classes/License";
import moment from "moment";

@Component({
  components: {},
})
export default class App extends Vue {
  name = "App";

  twitterIconPath = mdiTwitter;
  facebookIconPath = mdiFacebook;

  dataSetMinMonth = "2020-03";
  dataSetMaxMonth = "2020-05";
  datesFilterStore = ["2020-03", "2020-05"];
  datesFilter = ["2020-03", "2020-05"];
  get datesFilterString(): string {
    const sortedDates = this.datesFilter.sort();
    return `${moment(sortedDates[0]).format("YYYY-MM")} - ${moment(
      sortedDates[1]
    ).format("YYYY-MM")}`;
  }

  drawer = true;
  dateFilterOpen = false;
  fileErrorOpen = false;
  fileLoadingOpen = false;

  dataSet: DistroDataSet = new DistroDataSet();
  isDataAvailable = false;

  supportDialogOpen = false;
  supportDialogShow = true;

  @Watch("$route")
  showNagDialog() {
    if (
      this.$route.name === "Releases" &&
      this.supportDialogShow &&
      !License.isLicensed
    ) {
      this.supportDialogOpen = true;
    }
  }

  closeNagDialog(neverShow?: boolean) {
    this.supportDialogOpen = false;
    this.supportDialogShow = false;
    if (neverShow) {
      License.setLicense("NGS-PP-DNTD");
    }
  }

  private applyDatesFilter() {
    this.datesFilter = this.datesFilterStore.sort((d1, d2) =>
      d1 > d2 ? 1 : -1
    );
  }

  private async processDataFile(file: File | string) {
    this.fileLoadingOpen = true;
    this.$nextTick(() => this.completeProcessingDataFile(file));
  }

  private async completeProcessingDataFile(file: File | string) {
    try {
      this.dataSet = await DistroDataSet.createFromDataFile(file);
      this.isDataAvailable = this.dataSet && this.dataSet.length > 0;
    } catch (error) {
      this.isDataAvailable = false;
      this.fileErrorOpen = true;
    }
    this.fileLoadingOpen = false;
    if (this.isDataAvailable) {
      this.dataSetMinMonth =
        moment(this.dataSet.minMonth).format("YYYY-MM") || "2020-01";
      this.datesFilterStore[0] = this.dataSetMinMonth;
      this.dataSetMaxMonth =
        moment(this.dataSet.maxMonth).format("YYYY-MM") || "2025-01";
      this.datesFilterStore[1] = this.dataSetMaxMonth;
      this.applyDatesFilter();
      this.$router.push({ name: "Overview" });
    }
  }
}
